import type { PropsWithChildren, ReactNode } from 'react'

import styles from './PageBanner.module.scss'

interface PageBannerProps extends PropsWithChildren {
  content?: ReactNode
  leading?: ReactNode
  meta?: ReactNode
  subtitle?: ReactNode
  title?: ReactNode
  titleSuffix?: ReactNode
}

const PageBanner = ({
  children,
  content,
  leading,
  meta,
  subtitle,
  title,
  titleSuffix,
}: PageBannerProps) => (
  <div className={styles.pageBanner}>
    <div className={styles.content}>
      {content ?? (
        <div className={styles.titleGroup}>
          {leading}
          <div className={styles.textGroup}>
            {title && (
              <div className={styles.titleRow}>
                <h1>{title}</h1>
                {titleSuffix}
              </div>
            )}
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
            {meta && <div className={styles.meta}>{meta}</div>}
          </div>
        </div>
      )}
    </div>
    {children && <div className={styles.actions}>{children}</div>}
  </div>
)

export default PageBanner
